<template>
    <app-layout>
        <template #header>
            <div class="relative">
                <div class="absolute top-0 right-0">
                    Saldo PIX: <span class="font-bold">R$ {{ transactions.balance.value | currency }}</span>
                </div>
                <h2 class="font-semibold text-xl text-gray-800 leading-tight">
                    Extrato da carteira PIX
                </h2>
            </div>
        </template>
        <div class="py-12">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8">
                <div class="bg-white overflow-hidden shadow-xl sm:rounded-lg px-4 py-4">
                    <flash :timeout="5000"/>
                    <inertia-table
                        class="text-xs"
                        :data="transactions"
                        :params="params"
                        :filters="filters"
                        :columns="columns"
                        id="id"
                        routeName="pix-wallet.index"
                        @item-selected="show">
                        <template slot-scope="row" slot="created">
                            <div class="text-center">{{ row.item.created | smallDateTimeUtc }}</div>
                        </template>
                        <template slot-scope="row" slot="description">
                            <div class="text-left" v-if="row.item.operation_code === 'bank-fee'">
                                {{ row.item.operation_description || '' }}
                            </div>
                            <div class="text-left" v-else>{{ row.item.description || '' }}</div>
                        </template>
                        <template slot-scope="row" slot="name">
                            <div class="text-left">{{ (row.item.name || '') | capitalize }}</div>
                        </template>
                        <template slot-scope="row" slot="operation_code">
                            <div class="text-left">{{ row.item.operation_code || '' }}</div>
                        </template>
                        <template slot-scope="row" slot="federal_document">
                            <div class="text-left">{{ row.item.federal_document || '' }}</div>
                        </template>
                        <template slot-scope="row" slot="amount">
                            <div class="w-full text-right" v-bind:class="{
                                    'text-red-500': row.item.movement_type === 'D',
                                    'text-blue-500': row.item.movement_type === 'C',
                                }">{{ row.item.movement_type === 'D' ? '-' : '' }}{{ row.item.amount | currency }}
                            </div>
                        </template>
                    </inertia-table>
                </div>
            </div>
        </div>
    </app-layout>
</template>
<script>
import AppLayout from './../../Layouts/AppLayout';
import Welcome from './../../Jetstream/Welcome';
import Dropdown from '../../Jetstream/Dropdown';
import DropdownLink from '../../Jetstream/DropdownLink';
import JetAutoComplete from '../../Jetstream/AutoComplete';
import Flash from '../../Helpers/Flash';
import InertiaTable from '../../Helpers/Tables/InertiaTable';

export default {
    components: {
        Dropdown,
        AppLayout,
        Welcome,
        DropdownLink,
        Flash,
        JetAutoComplete,
        InertiaTable
    },
    props: ['transactions'],
    data() {
        return {
            columns: [
                {text: 'Data', className: 'text-center', key: 'created', sortable: true},
                {text: 'Descrição', className: 'text-left', key: 'description', sortable: false},
                {text: 'Pagador', className: 'text-left', key: 'name', sortable: false},
                {text: 'Cod.Conciliação', className: 'text-left', key: 'operation_code', sortable: false},
                {text: 'Documento', className: 'text-left', key: 'federal_document', sortable: false},
                {text: 'Valor', className: 'text-right', key: 'amount', sortable: false},
            ],
            filters: [
                {
                    text: 'Status',
                    key: 'status',
                    type: 'dropdown',
                    options: [
                        {id: 'pending', name: 'Pendente'},
                        {id: 'error', name: 'Erro de registro'},
                        {id: 'registered', name: 'Registrado'},
                        {id: 'paid', name: 'Pago'},
                        {id: 'expired', name: 'Vencido'},
                        {id: 'canceled', name: 'Cancelado'},
                    ]
                }
            ],
            statusList: {
                pending: 'Pendente',
                error: 'Erro',
                registered: 'Registrado',
                paid: 'Pago',
                expired: 'Vencido',
                canceled: 'Cancelado'
            },
            params: {
                sort: 'created:desc',
                page: 1,
                ...this.$page.props.queryString
            },
        }
    },
    methods: {
        show: function (item) {
            return;
        }
    }
}


</script>
